import axios from "axios";
import config from '../config';
import { CacheUtil } from "./cache";
import { message } from 'antd';


function retryAdapterEnhancer(adapter, options) {
    const { times = 0, delay = 300 } = options;

    return async (configure) => {
        const { retryTimes = times, retryDelay = delay } = configure;
        let __retryCount = 0;
        const request = async () => {
            try {
                return await adapter(configure);
            } catch (err) {
                if (!retryTimes || __retryCount >= retryTimes) {
                    return Promise.reject(err);
                }
                __retryCount++;
                const delay = new Promise((resolve) => {
                    setTimeout(() => {
                        resolve();
                    }, retryDelay);
                });
                return delay.then(() => {
                    return request();
                });
            }
        };
        return request();
    };
}


const createInstance = axios.create({
    baseURL: config.base_host + config.base_api,
    timeout: 3000,
    params: {
    },
    adapter: retryAdapterEnhancer(axios.defaults.adapter, {
        retryDelay: 300
    }),
});


createInstance.interceptors.request.use(
    configure => {
        const cacheUtil = new CacheUtil();
        const token = cacheUtil.getExpire('token') || '';
        if(token){
            configure.headers.token= token
        }
        return configure
    },
        error => {
            // Message.error(error);
            message.error(error);
            return Promise.reject(error)
    }
)


createInstance.interceptors.response.use(
    response => {
        if (response.data.errorCode && response.data.errorCode !== 0 ) {
            // Message.error(response.data.msg);
            message.error(response.data.msg);
            return Promise.reject(response.data.msg);
        }
        return response.data;
    },
    error => {
        if (error.response.status === 401) {
            // Message.error(error.response.data.msg, 1000);
            message.error(error.response.data.msg);
            localStorage.removeItem('token');
            setTimeout(() => {
                window.location.hash='#/login';
            }, 1000)
        } else {
            // Message.error(error.response.data.msg);
            message.error(error.response.data.msg);
            return Promise.reject(error.response.data.msg)
        }
    }
);

export default createInstance;